import type { WeekOption } from 'common/utils/schoolYearMonths';

/** `week_start` gửi LOGI = `date_from` của tuần đang chọn trên Thực đơn rút gọn. */
export function resolveSampleMealWeekStart(
  week: number | '' | undefined,
  options: WeekOption[]
): string | null {
  if (week === '' || week === undefined || week === null) return null;
  const found = options.find((o) => o.id === week);
  return found?.date_from ?? null;
}
